import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import Breakpoints from '../utils/breakpoints'
import Dimensions from 'react-dimensions'

export class HeaderMedia extends Component {


  randomizeVideo(){
    let randomInt = Math.floor(Math.random() * this.props.src.length);
    return this.props.src[randomInt];
  }

  render() {
    const isDesktop = this.props.containerWidth > Breakpoints.mobileScreenWidth;
    if (isDesktop) {
      return (
          <div className="video-container">
            <video playsInline autoPlay muted loop id="bgvid">
              <source src={this.randomizeVideo()} type={this.props.type}/>
            </video>
          </div>
      );
    } else {
     return (
          <div className="gif-container">
            <img alt="brand-feeling" src={this.props.mobileGif} />
          </div>
     )
    }
  }
}

export default Dimensions()(HeaderMedia);


// WEBPACK FOOTER //
// ../components/HeaderMedia.js